import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectCertificateDomain = (state) =>
  state.certificateList || initialState;

export const makeSelectLoading = () =>
  createSelector(selectCertificateDomain, (substate) => substate.loading);

export const makeSelectCertificates = () =>
  createSelector(selectCertificateDomain, (substate) => substate.certificates);

export const makeSelectTotal = () =>
  createSelector(selectCertificateDomain, (substate) => substate.total);

export const makeSelectPageNumber = () =>
  createSelector(selectCertificateDomain, (substate) => substate.pageNumber);

export const makeSelectPageSize = () =>
  createSelector(selectCertificateDomain, (substate) => substate.pageSize);

export const makeSelectSearch = () =>
  createSelector(selectCertificateDomain, (substate) => substate.search);

export const makeSelectColumns = () =>
  createSelector(selectCertificateDomain, (substate) => substate.columns);


export const makeSelectCertificateData = () =>
  createSelector(selectCertificateDomain, (substate) => substate.certificateData);


export const makeSelectLoadingDetail = () =>
  createSelector(selectCertificateDomain, (substate) => substate.loadingDetail);


export const makeSelectAssociatedProducts = () =>
  createSelector(
    selectCertificateDomain,
    (substate) => substate.associatedProducts
  );


export const makeSelectIsDisplayCertificateNew = () =>
  createSelector(
    selectCertificateDomain,
    (substate) => substate.isDisplayCertificateNew
  );

  export const makeSelectCertificateGridData = () =>
  createSelector(
    selectCertificateDomain,
    (substate) => substate.certificateGridData || []
  );

